import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { ParameterGroupSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/requests/ParameterGroupSearchRequestDTO'

export class ParameterGroupFiltersFormModel extends FormModel {

    @IsOptional()
    searchString?: string

    constructor(initialData?: Partial<ParameterGroupFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

    static formatDto(formStateManager: IFormStateManager<ParameterGroupFiltersFormModel>): ParameterGroupSearchRequestDTO {

        if (!formStateManager.getFormValues())
            return {}

        return {
            searchString: formStateManager.getFormValues()!.searchString,
        }
    }

}
